import * as React from "react";

;
export const GoesUp = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={14} fill="#039F7E" {...props}><path d="M6.722 3.646v10.02h-1V3.647C4.688 5.236 2.91 6.389.667 6.389v-1c3.017 0 5.045-2.508 5.055-5.036v-.02h1c0 2.535 2.03 5.056 5.056 5.056v1c-2.244 0-4.022-1.152-5.056-2.743Z" /></svg>;